import {
    duplicateProposal,
    partialUpdateProposal,
} from 'common/api/v1/proposals';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import filterProposals from '../../proposals/actions/filterProposals';
import {
    SAVE_PROPOSAL,
    SAVE_PROPOSAL_SUCCESS,
    SAVE_PROPOSAL_FAILURE,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

import openModal from './openModal';

export default (filterData, mode, values) => (dispatch) => {
    dispatch(createProposalModalActions[SAVE_PROPOSAL]());

    const newValues = {
        name: values.name,
        project: values.project,
    };

    const action =
        mode === 'duplicate'
            ? duplicateProposal(newValues, values.id)
            : partialUpdateProposal(newValues, values.id);

    action
        .then((response) => {
            dispatch(
                createProposalModalActions[SAVE_PROPOSAL_SUCCESS](
                    response.data,
                ),
            );
            dispatch(openModal(false));
            if (filterData) dispatch(filterProposals(filterData));
            showToast();
        })
        .catch((error) => {
            dispatch(
                createProposalModalActions[SAVE_PROPOSAL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
